import type { TOC } from '@ember/component/template-only'
import { TilesReporting } from 'teacher-ui-client/components/tiles/reporting'
import { ReportingDashboardHeader } from 'teacher-ui-client/components/tiles/reporting-dashboard/header'
import { NoDataMessage } from 'teacher-ui-client/components/no-data-message'

interface Args {
  title?: string
  tooltip?: string
  empty?: boolean
}

interface Signature {
  Args: Args
  Element: HTMLElement
  Blocks: {
    default: unknown[]
  }
}

export const ReportingDashboardDynamic: TOC<Signature> = <template>
  {{! Use this when you want the content to dictate the height of the panel. The content should know what height it wants }}
  <TilesReporting class="px-5 pt-4 pb-1" data-test-tiles-reporting-dashboard="dynamic" ...attributes>
    <ReportingDashboardHeader @title={{@title}} @tooltip={{@tooltip}} />
    <div>
      {{#if @empty}}
        <NoDataMessage @compact={{true}} class="m-4" />
      {{else}}
        {{yield}}
      {{/if}}
    </div>
  </TilesReporting>
</template>

export default ReportingDashboardDynamic
